import * as React from "react";

import MobileStart from "./components/mobile-start";
import WebStart from "./components/web-start";
import { useOutletContext } from "react-router-dom";

export default function Start() {

	const [handleChangeWebStyleLayout, layout] = useOutletContext();

	return (
		<React.Fragment>
			{layout === "mobile" 
				? <MobileStart />
				: <WebStart onChangeWebStyleLayout={handleChangeWebStyleLayout}/>
			}
		</React.Fragment>
	);
}
